<template>
<div> 
  <Cover />

  <Contact />
</div>
</template>

<script>
import Cover from "../components/Cover.vue"
import Contact from "../components/Contact.vue"


export default {
  name: 'HomeView',
  components: {
    Cover,
    Contact
  }
}
</script>

<style scoped>


</style>




